/* Ramvico · movimiento con propósito (JS). Ver ramvico-motion.css.
   - RamvicoToast: aviso flotante accesible (aria-live), un solo aviso a la vez, se cierra tocando la X, deslizando
     hacia abajo o solo a los segundos (se pausa mientras se mira o se enfoca).
   - Carrito: latido del contador al añadir; si el carrito lateral no llega a abrirse, aviso «Añadido al carrito».
   - Errores de «añadir al carrito» que quedan fuera de pantalla (barra fija de móvil): se repiten en un aviso.
   - Barra de oferta [data-rv-urgency]: cuenta atrás en días (solo texto, sin parpadeos).
   No toca precios, descuentos ni la lógica de los packs: solo observa. */
(function () {
  'use strict';

  var ICONS = {
    ok: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="10" cy="10" r="8.25"/><path d="M6.4 10.4l2.5 2.5 4.7-5.2"/></svg>',
    error: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="10" cy="10" r="8.25"/><path d="M10 5.8v5M10 13.9v.1"/></svg>',
    close: '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12"/></svg>'
  };

  var calm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* ───────────── Toast ───────────── */
  var host = null;
  var current = null;

  function ensureHost() {
    if (host && host.isConnected) return host;
    host = document.createElement('div');
    host.className = 'rv-toasts';
    host.setAttribute('aria-live', 'polite');
    host.setAttribute('aria-atomic', 'false');
    document.body.appendChild(host);
    return host;
  }

  function dismiss(t) {
    if (!t || t.closing) return;
    t.closing = true;
    clearTimeout(t.timer);
    t.el.classList.add('is-leave');
    var done = function () { if (t.el.parentNode) t.el.parentNode.removeChild(t.el); if (current === t) current = null; };
    if (calm.matches) done(); else setTimeout(done, 170);
  }

  function show(opts) {
    opts = opts || {};
    var message = String(opts.message || '').trim();
    if (!message) return null;
    var type = opts.type === 'error' ? 'error' : 'ok';
    if (current && current.message === message && Date.now() - current.at < 1500) return current; // mismo aviso repetido
    if (current) dismiss(current);

    var el = document.createElement('div');
    el.className = 'rv-toast is-enter' + (type === 'error' ? ' is-error' : '');
    el.setAttribute('role', type === 'error' ? 'alert' : 'status');
    el.innerHTML = '<span class="rv-toast__icon">' + ICONS[type] + '</span><div class="rv-toast__text"></div>' +
      '<button type="button" class="rv-toast__close" aria-label="Cerrar aviso">' + ICONS.close + '</button>';
    var text = el.querySelector('.rv-toast__text');
    text.appendChild(document.createTextNode(message));
    if (opts.action && opts.action.href) {
      var a = document.createElement('a');
      a.className = 'rv-toast__action';
      a.href = opts.action.href;
      a.textContent = opts.action.label || 'Ver';
      text.appendChild(document.createElement('br'));
      text.appendChild(a);
    }

    var t = { el: el, message: message, at: Date.now(), closing: false, timer: 0 };
    var duration = opts.duration || Math.min(9000, Math.max(3500, message.length * 55));
    function arm(ms) { clearTimeout(t.timer); t.timer = setTimeout(function () { dismiss(t); }, ms); }

    el.querySelector('.rv-toast__close').addEventListener('click', function () { dismiss(t); });
    el.addEventListener('pointerenter', function () { clearTimeout(t.timer); });
    el.addEventListener('pointerleave', function () { if (!t.closing) arm(1500); });
    el.addEventListener('focusin', function () { clearTimeout(t.timer); });
    el.addEventListener('focusout', function () { if (!t.closing) arm(1500); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') dismiss(t); });

    // Deslizar hacia abajo para descartar (el aviso sigue al dedo; si no llega al umbral, vuelve a su sitio)
    var startY = null, dy = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.target.closest('a, button')) return;
      startY = e.clientY; dy = 0; clearTimeout(t.timer);
      el.classList.add('is-drag');
      try { el.setPointerCapture(e.pointerId); } catch (err) { /* sin captura: se sigue igual */ }
    });
    el.addEventListener('pointermove', function (e) {
      if (startY === null) return;
      dy = Math.max(0, e.clientY - startY);
      el.style.transform = 'translateY(' + dy + 'px)';
    });
    function release() {
      if (startY === null) return;
      startY = null;
      el.classList.remove('is-drag');
      if (dy > 40) { el.style.transform = ''; dismiss(t); }
      else { el.style.transform = ''; arm(2000); }
    }
    el.addEventListener('pointerup', release);
    el.addEventListener('pointercancel', release);

    ensureHost().appendChild(el);
    current = t;
    // Dos fotogramas: el estado inicial se pinta y la entrada se anima de verdad
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.remove('is-enter'); }); });
    arm(duration);
    return t;
  }

  window.RamvicoToast = { show: show, dismiss: function () { dismiss(current); } };

  /* ───────────── Carrito ───────────── */
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  function bumpBubble() {
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!b) return;
    b.classList.remove('rv-bump');
    void b.offsetWidth; // reinicia la animación si se añade dos veces seguidas
    b.classList.add('rv-bump');
    b.addEventListener('animationend', function () { b.classList.remove('rv-bump'); }, { once: true });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      if (!C || !C.prototype.renderContents || C.prototype.renderContents.__rvWrapped) return;
      var orig = C.prototype.renderContents;
      C.prototype.renderContents = function () {
        var out = orig.apply(this, arguments);
        var drawer = this;
        setTimeout(bumpBubble, 120);
        // El carrito lateral es la confirmación. Si por lo que sea no se abre, el cliente no se queda sin respuesta.
        setTimeout(function () {
          if (!drawer.classList.contains('active')) show({ message: 'Añadido al carrito', action: { label: 'Ver carrito', href: cartUrl } });
        }, 700);
        return out;
      };
      C.prototype.renderContents.__rvWrapped = true;
    });
  }

  /* ───────────── Errores fuera de pantalla ───────────── */
  function offscreen(el) {
    var r = el.getBoundingClientRect();
    return r.bottom < 0 || r.top > window.innerHeight - 72; // 72 px: altura de la barra fija de compra
  }
  function surface(el) {
    if (!el || el.hidden || !el.textContent.trim()) return;
    if (!offscreen(el)) return; // si se ve, el mensaje en línea basta
    var link = el.querySelector('a[href]');
    show({
      message: el.textContent.replace(link ? link.textContent : '', '').trim(),
      type: 'error',
      action: link ? { label: link.textContent.trim(), href: link.getAttribute('href') } : null,
      duration: 8000
    });
  }
  function watchErrors() {
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'attributes') { if (m.target.matches && m.target.matches('[data-pm-error]')) surface(m.target); return; }
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches('.rv-error')) surface(n);
          else if (n.parentNode && n.parentNode.matches && n.parentNode.matches('[data-pm-error]')) surface(n.parentNode);
        });
        if (m.type === 'childList' && m.target.matches && m.target.matches('[data-pm-error]')) surface(m.target);
      });
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }

  /* ───────────── Barra de oferta ───────────── */
  function initUrgency() {
    document.querySelectorAll('[data-rv-urgency]').forEach(function (bar) {
      var endIso = bar.getAttribute('data-end');
      var out = bar.querySelector('[data-rv-urgency-count]');
      if (endIso && out) {
        var end = new Date(endIso + 'T23:59:59');
        var update = function () {
          var ms = end - Date.now();
          if (ms <= 0) { bar.hidden = true; return; }
          var days = Math.ceil(ms / 864e5);
          var label = days > 1 ? 'Quedan ' + days + ' días' : 'Último día';
          if (out.textContent !== label) out.textContent = label;
        };
        update();
        setInterval(update, 60000);
      }
      var close = bar.querySelector('[data-rv-urgency-close]');
      if (close) close.addEventListener('click', function () {
        bar.classList.add('is-dismissed');
        try { sessionStorage.setItem('rv-urgency-dismissed', '1'); } catch (e) { /* sin almacenamiento: vuelve a salir en otra página */ }
        setTimeout(function () { bar.hidden = true; }, calm.matches ? 0 : 300);
      });
    });
  }

  function init() {
    ensureHost();
    watchErrors();
    initUrgency();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
